import { OrderReportListItem } from './OrderReportListItem'
import { ProductImage } from 'utils/imageUtils'

interface Product {
  image?: string | ProductImage // Old format: string, or Cart/Order format: ProductImage object
  images?: ProductImage[] // New format: array of image objects
  title: string
}

interface StatusHistoryType {
  status: string
  changedAt: string | number | Date
}

interface OrderItems {
  discount: number
  id: string
  orderId: string
  ownerId: string
  product: Product
  productId: string
  quantity: number
  price: number
  shipmentTrackingCode: number | null
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  vat: number
}

interface Order {
  createdAt: string
  currency: string
  customerId: string
  discount: number
  id: string
  items: OrderItems[]
  receiverFirstName: string
  receiverLastName: string
  receiverTelephone: string
  shipmentTrackingCode: number | null
  shippingAddressCityId: number
  shippingAddressLatitude: number | null
  shippingAddressLongitude: number | null
  shippingAddressPostalCode: string
  shippingAddressText: string
  shippingPrice: number
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  vat: number
}

export const OrderReportList = ({ order }: { order: Order }) => {
  return (
    <div>
      <ul className='order-item-wrap'>
        {order.items.map((item) => (
          <OrderReportListItem key={item.id} orderItems={item} />
        ))}
      </ul>
    </div>
  )
}
